import React from 'react';

/**
 * SafePanel — light error boundary that catches any render/effect crash
 * inside a single admin panel and shows a compact inline error card
 * instead of black-screening the whole Settings tab. Every top-level
 * panel on `SettingsAdminTab` is wrapped in this — a single stale field
 * or bad response can't take down the entire tab anymore.
 */
class SafePanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = { failed: false, err: null };
    }
    static getDerivedStateFromError(err) {
        return { failed: true, err };
    }
    componentDidCatch(err, info) {
        // eslint-disable-next-line no-console
        console.error(`SafePanel [${this.props.label || 'panel'}] crashed:`, err, info);
    }
    render() {
        if (this.state.failed) {
            return (
                <div
                    className="rounded-xl border border-red-500/30 bg-red-500/5 p-4 text-[13px]"
                    data-testid={`safepanel-error-${this.props.label || 'panel'}`}
                >
                    <div className="font-black text-red-400 mb-1">
                        {this.props.label || 'Panel'} temporarily unavailable
                    </div>
                    <div className="text-red-300/80 text-[11px] leading-snug">
                        This section hit a rendering error. The rest of the Settings tab is safe.
                        Refresh the page to try again — details in the browser console.
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default SafePanel;
